import { render, staticRenderFns } from "./FormUiComponentMenu.vue?vue&type=template&id=50ef4f57&"
import script from "./FormUiComponentMenu.vue?vue&type=script&lang=js&"
export * from "./FormUiComponentMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports